/** 引入Vue库 */
import Vue from 'vue'

/** 引入Vue-router路由库 */
import Router from 'vue-router'

/** 解决重复点击同一个路由造成的报错 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

/** 引入提示弹窗 */
// import { MessageTime } from '../utils/Tool'

/** 引入Api自动登录 */
import Api from '../api/index'

/** Router路由进行实例化 */
Vue.use(Router)


// import common from './modules/common';
import Error from '@/components/Error/index' //404
import index from '@/pages/index/index';
import international from '@/pages/international/index';
import china from '@/pages/china/index';
import ganzi from '@/pages/ganzi/index';
import login from '@/pages/login/index';
import sell from '@/pages/ganzi/sell';
import qulaAcquisition from '@/pages/ganzi/qulaAcquisition';
// 康巴圣德下游应用企业：热力图页 + 企业详情页（由经营数据页「下游客户热力图」标签进入）
import downstreamHeat from '@/pages/ganzi/downstream-heat';
import companyDetail from '@/pages/ganzi/company-detail';
// 甘孜市场 → 酪蛋白产业链数字化（架构图主页面 + 占位下级页）
import industryChain from '@/pages/ganzi/industry-chain';
import chainSub from '@/pages/ganzi/chain-sub';
// 产业链「产品研发 / 生产安全 / 工艺流程」三个下级页面（+ 各自的详情下级页）
import productResearch from '@/pages/ganzi/product-research';
import safetyFlow from '@/pages/ganzi/safety-flow';
import safetyDevice from '@/pages/ganzi/safety-device';
import processFlow from '@/pages/ganzi/process-flow';
import processDemo from '@/pages/ganzi/process-demo';
// 内容管理后台：所有页面的文字 / 图片 / 视频 / 数据统一在 /cms 维护（旧 /admin 三页已废弃，重定向到此）
import cms from '@/pages/cms/Index';
import h5 from '@/pages/h5/index';

/** 配置路由文件 */

const router = new Router({
	mode: 'hash',
	// 子路径部署：生产环境经 .env.production 设为 /kanban/；本地 dev 读不到变量时回落 '/'
	base: process.env.VUE_APP_ROUTER_BASE || '/',
	routes: [
      {path: '', redirect: '/index' },
      {path: '/login', name:'login', component: login, meta: {requireLogin : false, layout: 'main-layout'}},
      {path: '/index', name:'index', component: index, meta: {requireLogin : true, layout: 'main-layout'}},
      {path: '/international', name:'international', component: international, meta: {requireLogin : true, layout: 'main-layout'}},
      {path: '/china', name:'china', component: china, meta: {requireLogin : true, layout: 'main-layout'}},
      {path: '/ganzi', name:'ganzi', component: ganzi, meta: {requireLogin : true, layout: 'main-layout'}},
      {path: '/sell', name:'sell', component: sell, meta: {requireLogin : true, layout: 'main-layout'}},
      {path: '/downstream-heat', name:'downstreamHeat', component: downstreamHeat, meta: {requireLogin : true, layout: 'main-layout'}},
      {path: '/company-detail/:id', name:'companyDetail', component: companyDetail, meta: {requireLogin : true, layout: 'main-layout'}},
      {path: '/qula-acquisition', name:'qulaAcquisition', component: qulaAcquisition, meta: {requireLogin : true, layout: 'main-layout'}},
      {path: '/industry-chain', name:'industryChain', component: industryChain, meta: {requireLogin : true, layout: 'main-layout'}},
      {path: '/chain-sub/:name', name:'chainSub', component: chainSub, meta: {requireLogin : true, layout: 'main-layout'}},
      {path: '/product-research', name:'productResearch', component: productResearch, meta: {requireLogin : true, layout: 'main-layout'}},
      {path: '/safety-flow', name:'safetyFlow', component: safetyFlow, meta: {requireLogin : true, layout: 'main-layout'}},
      {path: '/safety-device/:name', name:'safetyDevice', component: safetyDevice, meta: {requireLogin : true, layout: 'main-layout'}},
      {path: '/process-flow', name:'processFlow', component: processFlow, meta: {requireLogin : true, layout: 'main-layout'}},
      {path: '/process-demo/:name', name:'processDemo', component: processDemo, meta: {requireLogin : true, layout: 'main-layout'}},
      // 内容管理后台（自带登录，不依赖大屏 session；blank-layout 不受大屏 7680 缩放影响）
      {path: '/cms', name: 'cms', component: cms, meta: {requireLogin: false, layout: 'blank-layout'}},
      // 旧后台三页已废弃，统一重定向到新内容后台
      {path: '/admin', redirect: '/cms' },
      {path: '/admin/international', redirect: '/cms' },
      {path: '/admin/china', redirect: '/cms' },
      {path: '/admin/ganzi', redirect: '/cms' },
      {path: '/h5', name:'h5', component: h5, meta: {requireLogin : false, layout: 'blank-layout'}},
    {
        path: '*',
        name: 'Error',
        component: Error,
        meta :{ layout: 'blank-layout', noNeedLogin : true}
    },
    ]
})
router.beforeEach(async (to, from, next) => {   
    // 桌面端（Electron）为 kiosk 大屏，无需人工登录，直接放行受保护页面；CMS 走自身登录
    const isElectron = typeof navigator !== 'undefined' && /Electron/.test(navigator.userAgent)
    let isLogin = isElectron ? true : JSON.parse(sessionStorage.getItem('username_1'));
    if(to.meta.requireLogin){
        if(isLogin){
            next()
        }else{
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            })
        }
    }else{
        next()
    }
})

export default router
